"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AsyncComponent", {
  enumerable: true,
  get: function get() {
    return _AsyncComponent["default"];
  }
});
var _AsyncComponent = _interopRequireDefault(require("./AsyncComponent"));